export default "__VITE_ASSET__DamhHcxi__"